// extracted by mini-css-extract-plugin
export var container = "_5j-0";
export var fallback = "_5j-5";
export var fallbackIcon = "_5j-6";
export var hidden = "_5j-2";
export var image = "_5j-3";
export var loaded = "_5j-4";
export var placeholder = "_5j-1";